import StrawberryLayout from '@/components/layouts/StrawberryLayout'
import PCHomeLayout from '@/components/layouts/PCHomeLayout'
import ECosmeticsLayout from '@/components/layouts/ECosmeticsLayout'
import AcmilanLayout from '@/components/layouts/AcmilanLayout'
import FiveStarLayout from '@/components/layouts/FiveStarLayout'
import uDesignLayout from '@/components/layouts/uDesignLayout'
import EglToursLayout from '@/components/layouts/EglToursLayout'
import TenMartLayout from '@/components/layouts/TenMartLayout'
import SothebysLayout from '@/components/layouts/SothebysLayout'
import CorneyBarrowLayout from '@/components/layouts/CorneyBarrowLayout'
import WinnerPickleBallLayout from '@/components/layouts/WinnerPickleBallLayout'
import PacificPineSportsLayout from '@/components/layouts/PacificPineSportsLayout'
import KBJewelsLayout from '@/components/layouts/KBJewelsLayout'
import KiyaanJewelleryLayout from '@/components/layouts/KiyaanJewelleryLayout'
import ShopLayout from '@/components/layouts/ShopLayout'
import PXECLayout from '@/components/layouts/PXECLayout'
import SquareRecordsLayout from '@/components/layouts/SquareRecordsLayout'
import HKFECLayout from '@/components/layouts/HKFECLayout'
import XorroLayout from '@/components/layouts/XorroLayout'
import Area02Layout from '@/components/layouts/Area02Layout'
import GlobalMallLayout from '@/components/layouts/GlobalMallLayout'

export const STRAWBERRY_MERCHANT_ID = '250'

export const VALID_BRAND_NAME = {
  STRAWBERRY: 'strawberry',
  PCHOME: 'pchome',
  ECOSMETICS: 'ecosmetics',
  ACMILAN: 'acmilan',
  FIVE_STAR: 'five-star',
  UDESIGN: 'udesign',
  EGL_TOURS: 'egl-tours',
  TEN_MART: 'ten-mart',
  SOTHEBYS: 'sothebys',
  CORNEY_BARROW: 'corney-barrow',
  WINNER_PICKLE_BALL: 'winnerpickleball',
  PACIFIC_PINE_SPORTS: 'pacific-pine-sports',
  KB_JEWELS: 'kb-jewels',
  KIYAAN_JEWELLERY: 'kiyaan-jewellery',
  // 給 demo 隱藏商品用
  SHOP: 'shop',
  PXEC: 'pxec',
  SQUARE_RECORDS: 'square-records',
  HKFEC: 'hkfec',
  XORRO: 'xorro',
  AREA02: 'area02',
  GLOBAL_MALL: 'global-mall',
}

export type TValidBrandName = (typeof VALID_BRAND_NAME)[keyof typeof VALID_BRAND_NAME]

export const BRAND_LAYOUT = {
  [VALID_BRAND_NAME.STRAWBERRY]: StrawberryLayout,
  [VALID_BRAND_NAME.PCHOME]: PCHomeLayout,
  [VALID_BRAND_NAME.ECOSMETICS]: ECosmeticsLayout,
  [VALID_BRAND_NAME.ACMILAN]: AcmilanLayout,
  [VALID_BRAND_NAME.FIVE_STAR]: FiveStarLayout,
  [VALID_BRAND_NAME.UDESIGN]: uDesignLayout,
  [VALID_BRAND_NAME.EGL_TOURS]: EglToursLayout,
  [VALID_BRAND_NAME.TEN_MART]: TenMartLayout,
  [VALID_BRAND_NAME.SOTHEBYS]: SothebysLayout,
  [VALID_BRAND_NAME.CORNEY_BARROW]: CorneyBarrowLayout,
  [VALID_BRAND_NAME.WINNER_PICKLE_BALL]: WinnerPickleBallLayout,
  [VALID_BRAND_NAME.PACIFIC_PINE_SPORTS]: PacificPineSportsLayout,
  [VALID_BRAND_NAME.KB_JEWELS]: KBJewelsLayout,
  [VALID_BRAND_NAME.KIYAAN_JEWELLERY]: KiyaanJewelleryLayout,
  [VALID_BRAND_NAME.SHOP]: ShopLayout,
  [VALID_BRAND_NAME.PXEC]: PXECLayout,
  [VALID_BRAND_NAME.SQUARE_RECORDS]: SquareRecordsLayout,
  [VALID_BRAND_NAME.HKFEC]: HKFECLayout,
  [VALID_BRAND_NAME.XORRO]: XorroLayout,
  [VALID_BRAND_NAME.AREA02]: Area02Layout,
  [VALID_BRAND_NAME.GLOBAL_MALL]: GlobalMallLayout,
}
